import * as _ from "lodash";
import { Action } from "redux";
import { ThunkResult, Utilities } from "../../shared/utilities";
import { filterIsOnCountsAndOlderThanCurrentTimeLimit } from "../model/AppPath";
import { FilterCategory } from "../model/ListState";
import { TaskModel } from "../model/Search";
import { getCurrentAgentGroup, State } from "../model/State";

import { fetchFinish, FetchId, fetchStart, fetchSubprocessUsageData, reportFetchError, shouldFetchSubprocessUsageData } from "./FetchActions";
import { changeCountsTimeLimitDays } from "./ProcessListActions";

export function fetchTasks(): ThunkResult<void, State> {
    return (dispatch) => {
        dispatch(fetchStart(FetchId.tasks));
        fetch(`api/processList/tasks`,
            { credentials: "same-origin" })
            .then(Utilities.parseJsonResponse)
            .then((data: TaskModel[]) => {
                dispatch(receiveTasks(data));
                dispatch(fetchFinish(FetchId.tasks));
            })
            .catch((err) => dispatch(reportFetchError(err)));
    };
}

export const RECEIVE_TASKS = "RECEIVE_TASKS";
function receiveTasks(data: TaskModel[]): ReceiveTasksAction {
    return {
        type: RECEIVE_TASKS,
        taskData: data
    };
}

export interface ReceiveTasksAction extends Action {
    taskData: TaskModel[];
}

export function changeFilter(newValue: string | null, newCategory: string): ThunkResult<void, State> {
    return async (dispatch, getState) => {
        const state = getState();
        if (filterIsOnCountsAndOlderThanCurrentTimeLimit(newCategory, newValue, state.listState.countsTimeLimitDays)) {
            dispatch(changeCountsTimeLimitDays(0)); // reset to all
        }

        if (_.isEmpty(state.referencedProcessMap) && shouldFetchSubprocessUsageData(newCategory)) {
            const currentAgentGroup = getCurrentAgentGroup(state);
            dispatch(fetchSubprocessUsageData(currentAgentGroup.environment, currentAgentGroup.name));
        }

        if (_.isEmpty(state.tasks) && newCategory === FilterCategory.Tasks) {
            dispatch(fetchTasks());
        }
    };
}

export interface ChangeFilterAction extends Action {
    filter: string;
    filterCategory: FilterCategory;
}

export const CLEAR_FILTERS = "CLEAR_FILTERS";
export function clearFilters(): Action {
    return {
        type: CLEAR_FILTERS,

    };
}
